import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { InvoiceGroups } from 'src/shared/components/form/invoiceGroups';
import { useFormContext } from 'react-hook-form';
import { EventTypeSelector } from './eventTypeSelector';

export const EventFormStepEventType = () => {
  const { setValue, getValues } = useFormContext();

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <Typography variant='body1' sx={{ fontWeight: 600, mb: -1 }}>
          {t('event:chooseEventType')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <EventTypeSelector />
      </Grid>
    </GridWrapper>
  );
};
